import styled from 'styled-components';

export const Version = styled('div')`
  display: flex;
  justify-content: center;
  padding: ${({ theme: { spacing } }) => spacing(8)} 0;
`;
